export default __webpack_public_path__ + "static/media/BlindOff.bfc779df.svg";